<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapGetters, mapActions } from "vuex";
import { formatIST } from "../../../config/moment";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      formatIST,
      title: "Dashboard",
    };
  },
  computed: mapGetters("dashboard", [
    "loading",
    "chargerCounts",
    "bookingCounts",
    "userCounts",
    "dataCounts",
    "todayBookings",
    "todayChargers",
  ]),
  methods: {
    ...mapActions("dashboard", [
      "chargerCount",
      "bookingCount",
      "userCount",
      "dataCount",
    ]),
  },
  mounted() {
    let data = {};
    this.chargerCount(data);
    this.bookingCount(data);
    this.userCount(data);
    this.dataCount(data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-6">
        <a @click="showFollowers()">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">
                    Total Pre Auth Payments
                  </p>
                  <h4 class="mb-0">
                    <!-- ₹ {{ dataCounts.total_pre_auth_payment }} -->
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bxs-bank font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6">
        <a @click="showFollowers()">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">
                    Total Final Payments
                  </p>
                  <!-- <h4 class="mb-0">₹ {{ dataCounts.total_final_payment }}</h4> -->
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bxs-bank font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">
      <!-- Charger Section Start -->
      <div class="col-md-4">
        <router-link :to="{ name: 'booking-list' }">
          <a @click="showFollowers()">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">Total Bookings</p>
                    <h4 class="mb-0">
                      {{ bookingCounts }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bxs-bookmark-plus font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <!-- Charger Section End -->
      <!-- Booking Section Start -->
      <div class="col-md-4">
        <router-link :to="{ name: 'charger-details' }">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="media">
                <div class="media-body">
                  <p class="text-dark font-weight-medium">
                    Total Charging Stations
                  </p>
                  <h4 class="mb-0">
                    {{ chargerCounts }}
                  </h4>
                </div>
                <div
                  class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                >
                  <span class="avatar-title">
                    <i class="bx bx-usb font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <!-- Booking Section End -->
      <!-- User Section Start -->
      <div class="col-md-4">
        <router-link :to="{ name: 'user-list' }">
          <a @click="showFollowers()">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">Total Users</p>
                    <h4 class="mb-0">
                      {{ userCounts }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-user font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <!-- User Section End -->
    </div>

    <!-- Booking Section Start -->
    <div class="row">
      <div class="col-md-3">
        <router-link :to="{ name: 'booking-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      This Week's Bookings
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.booking_current_week_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bxs-bookmark-plus font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>

      <div class="col-md-3">
        <router-link :to="{ name: 'booking-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      Last Week's Bookings
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.booking_last_week_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bxs-bookmark-plus font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'booking-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      This Month's Bookings
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.booking_this_month_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bxs-bookmark-plus font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'booking-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      Last Month's Bookings
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.booking_privious_month_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bxs-bookmark-plus font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
    </div>
    <!-- Booking Section End -->

    <!-- Charger Section Start -->
    <div class="row">
      <div class="col-md-3">
        <router-link :to="{ name: 'charger-details' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      This Week's New Charging Stations
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.charger_current_week_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-usb font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'charger-details' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      Last Week's Charging Stations
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.charger_last_week_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-usb font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'charger-details' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      This Month's New Charging Stations
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.charger_this_month_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-usb font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'charger-details' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      Last Month's Charging Stations
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.charger_privious_month_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-usb font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
    </div>
    <!-- Charger Section End -->

    <!-- User Section Start -->
    <div class="row">
      <div class="col-md-3">
        <router-link :to="{ name: 'user-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      This Week's New Users
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.user_current_week_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-user font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'user-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      Last Week's Users
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.user_last_week_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-user font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'user-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      This Month's New Users
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.user_this_month_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-user font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
      <div class="col-md-3">
        <router-link :to="{ name: 'user-list' }">
          <a href="#">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="media-body">
                    <p class="text-dark font-weight-medium">
                      Last Month's Users
                    </p>
                    <h4 class="mb-0">
                      {{ dataCounts.user_privious_month_count }}
                    </h4>
                  </div>
                  <div
                    class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary"
                  >
                    <span class="avatar-title">
                      <i class="bx bx-user font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </router-link>
      </div>
    </div>
    <!-- User Section End -->

    <div class="row">
      <!-- Today's Bookings Section Start -->
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex" style="justify-content: space-between">
              <div class="me-2">
                <h5 class="card-title mb-4">Today's Bookings</h5>
              </div>
            </div>
            <div class="table-responsive scroll">
              <table class="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th scope="col">Station</th>
                    <th scope="col">City</th>
                    <th scope="col">Start Time</th>
                    <th scope="col">End Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="todayBookings == 0">
                    <td colspan="100%">
                      <h6 align="center">No Data Found</h6>
                    </td>
                  </tr>
                  <tr
                    v-for="(booking, index) in todayBookings"
                    :key="booking.id"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{ booking.chargers ? booking.chargers.name : "-" }}
                    </td>
                    <td>
                      {{ booking.chargers ? booking.chargers.city : "-" }}
                    </td>
                    <td>
                      {{ formatIST(booking.start_time) }}
                    </td>
                    <td>
                      {{ formatIST(booking.end_time) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Today's Bookings Section End -->
      <!-- Today's Charger Stations Section Start -->
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex" style="justify-content: space-between">
              <div class="me-2">
                <h5 class="card-title mb-4">Today's Charger Stations</h5>
              </div>
            </div>
            <div class="table-responsive scroll">
              <table class="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Address</th>
                    <th scope="col">Start Time</th>
                    <th scope="col">End Time</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="todayChargers == 0">
                    <td colspan="100%">
                      <h6 align="center">No Data Found</h6>
                    </td>
                  </tr>
                  <tr
                    v-for="(charger, index) in todayChargers"
                    :key="charger.id"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ charger.name ? charger.name : "-" }}</td>
                    <td>
                      {{ charger.address ? charger.address : "-" }}
                    </td>
                    <td>
                      {{ formatIST(charger.start_time) }}
                    </td>
                    <td>
                      {{ formatIST(charger.end_time) }}
                    </td>
                    <td>
                      {{ charger.is_private == 1 ? "Private" : "Public" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Today's Charger Stations Section End -->
    </div>
  </Layout>
</template>
<style>
.scroll {
  width: 110px;
  height: 280px;
  overflow: scroll;
}
</style>
